import type { ChannelReads } from '@here/api'
import { createEffect, createResource, createSignal } from 'solid-js'
import { useService } from 'solid-services'
import { userId } from '../auth'
import { useMessageMeta } from '../messageMeta'
import { handleGetChannelReads, whenChannelSeen } from './resources'
import { debug } from 'console'

export function useChannelsReads() {
	const { messageMetaResource } = useService(useMessageMeta)()
	const [channelRead, setChannelRead] = createSignal<Partial<ChannelReads>>()

	const [channelReadsResource, { refetch: channelReadsRefetch }] = createResource(
		userId,
		handleGetChannelReads,
		{
			initialValue: [],
		},
	)

	const [channelSeenResource] = createResource(
		() => ({
			userId: userId(),
			channelRead: channelRead(),
		}),
		({ userId, channelRead }) => whenChannelSeen(userId, channelRead),
	)

	const channelReadDictionary = () => {
		const reads = channelReadsResource()
		if (reads) {
			const dictionary = reads.reduce(
				(acc, read) => {
					acc[read.channel_id] = read
					return acc
				},
				{} as Record<string, ChannelReads>,
			)

			return dictionary
		}

		return {}
	}

	const setChannelReadSubscription = (is_subscribed: boolean, channelId: string) => {
		if (!channelReadDictionary()) return

		const c = channelReadDictionary()![channelId]

		setChannelRead({
			...c,
			is_subscribed,
		})
	}

	const toggleSubscribed = async (channelId?: string) => {
		if (!channelId) return

		if (channelReadDictionary()[channelId]) {
			const { is_subscribed } = channelReadDictionary()[channelId]
			if (is_subscribed === true) {
				setChannelReadSubscription(false, channelId)
			} else if (is_subscribed === false) {
				// set channel reads true
				setChannelReadSubscription(true, channelId)
			}
		} else {
			// create new channel read
			// TODO add this in, i need the last read message id for the channel though, probably can request this in the resource??
			const meta = messageMetaResource()?.find((meta) => meta.channel_id === channelId)

			if (meta) {
				setChannelRead({
					channel_id: channelId,
					last_read_message_id: meta.last_message_id,
					last_read_at: meta.last_message_at,
					is_subscribed: true,
				})
			}
		}
	}

	createEffect(() => {
		if (channelSeenResource.state === 'ready') {
			// channelReadsRefetch()
		}
	})

	return {
		toggleSubscribed,
		setChannelReadSubscription,
		channelSeenResource,
		setChannelRead,
		channelReadsRefetch,
		channelReadsResource,
		channelReadDictionary,
	}
}
